"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Input_1 = __importDefault(require("../Input"));
function InputIcon(_a) {
    var wrapperClassName = _a.wrapperClassName, icon = _a.icon, iconClassName = _a.iconClassName, id = _a.id, inputClassName = _a.inputClassName, onSearchTextChange = _a.onSearchTextChange, placeholder = _a.placeholder, value = _a.value, _b = _a.type, type = _b === void 0 ? 'text' : _b;
    return (react_1.default.createElement("div", { className: wrapperClassName },
        react_1.default.createElement("label", { htmlFor: id },
            react_1.default.createElement("i", { className: "".concat(icon, " ").concat(iconClassName) })),
        react_1.default.createElement(Input_1.default, { value: value, onTextChange: onSearchTextChange, type: type, id: id, className: inputClassName, placeholder: placeholder })));
}
exports.default = InputIcon;
